import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import client from "../configs/sanityClient";

export const fetchPays = createAsyncThunk(
  "pays/fetchPays",
  async (_, { rejectWithValue }) => {
    try {
      console.log('Starting pays fetch...');
      const query = `*[_type == "pays"]{
        _id,
        nom,
        dbId,
        "image": image[]->{path, alt, type}
      }`;
      
      console.log('Executing Sanity query:', query);
      const paysData = await client.fetch(query);
      console.log('Raw pays data received:', paysData);
      
      if (!paysData || paysData.length === 0) {
        console.warn('No countries found in the response');
        return rejectWithValue('No countries found');
      }
      
      // Validate and clean the data - only include pays with images
      const validPays = paysData.filter(pay => {
        const isValid = pay && pay._id && pay.nom && pay.dbId;
        const hasImage = pay.image && pay.image.length > 0 && pay.image[0]?.path;
        if (!isValid) {
          console.warn('Invalid pay data found:', pay);
        }
        if (!hasImage) {
          console.warn('Pay without image found:', pay.nom);
        }
        return isValid && hasImage;
      });

      console.log('Validated pays data:', validPays);

      if (validPays.length === 0) {
        console.error('No valid countries found after validation');
        return rejectWithValue('No valid countries found');
      }

      // Sort pays alphabetically by name
      validPays.sort((a, b) => a.nom.localeCompare(b.nom));

      return validPays;
    } catch (error) {
      console.error('Error in fetchPays:', error);
      return rejectWithValue(error.message || 'Failed to fetch countries');
    }
  }
);

const paysSlice = createSlice({
  name: "pays",
  initialState: {
    items: [],
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
    lastFetched: null,
    retryCount: 0,
  },
  reducers: {
    clearPaysError: (state) => {
      state.error = null;
    },
    resetPaysState: (state) => {
      state.items = [];
      state.status = "idle";
      state.error = null;
      state.lastFetched = null;
      state.retryCount = 0;
    },
    incrementRetryCount: (state) => {
      state.retryCount += 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPays.pending, (state) => {
        console.log('Pays fetch pending...');
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchPays.fulfilled, (state, action) => {
        console.log('Pays fetch succeeded:', action.payload);
        state.status = "succeeded";
        state.items = action.payload;
        state.error = null;
        state.lastFetched = new Date().toISOString();
        state.retryCount = 0;
      })
      .addCase(fetchPays.rejected, (state, action) => {
        console.error('Pays fetch failed:', action.payload);
        state.status = "failed";
        state.error = action.payload;
        state.retryCount += 1;
      });
  },
});

export const { clearPaysError, resetPaysState, incrementRetryCount } = paysSlice.actions;
export default paysSlice.reducer;
